import Flickity from 'flickity-imagesloaded';

const carousel = document.querySelector('.featured-article__carousel');

if (carousel) {
    new Flickity(carousel, {
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        cellAlign: 'left',
    });
}
